class PriceCheckboxFilter extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
    this.collectionInfo = document.querySelector('collection-info');
    this.bindEvents();
  }

  bindEvents() {
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      checkbox.addEventListener('click', (e) => e.stopPropagation());
    });

    this.setupInitialState();
  }

  setupInitialState() {
    // Get current URL parameters
    const params = new URLSearchParams(window.location.search);
    const minValue = params.get('filter.v.price.gte');
    const maxValue = params.get('filter.v.price.lte');

    if (minValue && maxValue) {
      // Check all checkboxes that fall within the current price range
      this.checkboxes.forEach(checkbox => {
        const checkboxMin = parseInt(checkbox.value);
        const checkboxMax = checkbox.getAttribute('data-second-value') ?
          parseInt(checkbox.getAttribute('data-second-value')) : Infinity;

        const urlMin = parseInt(minValue);
        const urlMax = parseInt(maxValue);

        if (checkboxMin >= urlMin && checkboxMax <= urlMax) {
          checkbox.checked = true;
        }
      });
    } else if (minValue && !maxValue) {
      this.checkboxes.forEach(checkbox => {
        const checkboxMin = parseInt(checkbox.value);
        const urlMin = parseInt(minValue);

        if (checkboxMin >= urlMin) {
          checkbox.checked = true;
        }
      });
    }
  }

  handleCheckboxChange(event) {
    event.preventDefault();
    event.stopPropagation();

    const newUrl = this.buildUrlWithAllFilters();
    this.collectionInfo.updateUrlHistory(newUrl);
    this.triggerFilterChangedEvent();
  }

  triggerFilterChangedEvent() {
    this.dispatchEvent(new Event('change', { bubbles: true }));
  }

  buildUrlWithAllFilters() {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');

    const checkedRanges = [];
    this.checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const minPrice = checkbox.value;
        const maxPrice = checkbox.getAttribute('data-second-value');
        checkedRanges.push({ min: minPrice, max: maxPrice });
      }
    });

    if (checkedRanges.length > 0) {
      const overallMin = Math.min(...checkedRanges.map(range => parseInt(range.min)));
      const maxValues = checkedRanges.map(range => range.max ? parseInt(range.max) : Infinity);
      const overallMax = Math.max(...maxValues);

      params.set('filter.v.price.gte', overallMin.toString());
      if (overallMax !== Infinity) {
        params.set('filter.v.price.lte', overallMax.toString());
      }
    }

    return `${url.pathname}?${params.toString()}`;
  }
}

if (!customElements.get('price-checkbox-filter')) {
  customElements.define('price-checkbox-filter', PriceCheckboxFilter);
}